import { Experiment } from '@types'
import survey from './survey'
import r1 from './r1'
import r2 from './r2'

const experiments: Experiment[] = [survey, r1, r2]

export default experiments
